var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'wspo-theme-office': _vm.context === 'office' || _vm.context === 'td',
    'wspo-theme-pm': _vm.context === 'pm' || _vm.context === 'main-pm'
  },attrs:{"id":"wspo"}},[_c('Lead')],1)}
var staticRenderFns = []

export { render, staticRenderFns }